<div class="module">
    <router-outlet></router-outlet>
</div>
<div class="footer" *ngIf="user">
    <a [routerLink]="['/logout']">
        <i class="fa fa-sign-out" aria-hidden="true"></i>
        Logout ({{user?.name?.trim()}})
    </a>
</div>